interface SortableRisk {
  handledAt?: string | null;
  comment?: { at?: string | null } | null;
}

/**
 * 风险列表排序：按处置时刻倒序，最近处理的排最前；未处理（无时刻）的垫底。
 *
 * 时刻优先取留言时刻（留言可改，是最新的），无留言时回落到处置动作本身的时刻 ——
 * 「联系 DSP」这类动作不产生留言，只有 handledAt。
 *
 * 工作台日报与片区复盘仓卡共用：两处展示的是同一批风险，排序口径分开写会漂。
 */
export const byHandledAtDesc = (a: SortableRisk, b: SortableRisk): number => {
  const at = (risk: SortableRisk) => risk.comment?.at ?? risk.handledAt ?? '';
  if (!at(a) || !at(b)) {
    return Number(!at(a)) - Number(!at(b));
  }
  return at(b).localeCompare(at(a));
};
